(function () {
  'use strict';

  function setDirection(form, value) {
    if (form && value) form.setAttribute('data-default-direction', value);
  }

  document.querySelectorAll('.js-topic-chips').forEach(function (group) {
    var form = group.closest('form');
    var qCase = form ? form.querySelector('[name="q_case_type"]') : null;
    group.querySelectorAll('.topic-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        group.querySelectorAll('.topic-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var val = chip.getAttribute('data-topic') || chip.textContent.trim();
        if (qCase) qCase.value = val;
        setDirection(form, val);
      });
    });
  });

  document.querySelectorAll('.js-caller-role').forEach(function (group) {
    var form = group.closest('form');
    var roleInput = form ? form.querySelector('[name="q_caller_role"]') : null;
    var nameInput = form ? form.querySelector('[name="customer_name"]') : null;
    group.querySelectorAll('.caller-role-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        group.querySelectorAll('.caller-role-tab').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var role = tab.getAttribute('data-role') || tab.textContent.trim();
        if (roleInput) roleInput.value = role;
        if (nameInput) {
          nameInput.placeholder = role.indexOf('Родич') !== -1
            ? 'Ваше ім’я (дружина / мати / батько)'
            : 'Ваше ім’я (або позивний)';
        }
      });
    });
  });

  var iqRoot = document.getElementById('inlineQuiz');
  if (!iqRoot) return;

  var VERDICTS = {
    szch: 'По справах СЗЧ (ст. 407, 408 ККУ) адвокат дистанційно перевіряє статус у ЄРДР та ДБР і супроводжує отримання письмової згоди (відношення) в іншу частину або звільнення від відповідальності через суд без ризику СІЗО. Договір може підписати сам військовий або дружина / мати за 15 хвилин.',
    vlk: 'За вашою ситуацією можливе подання мотивованої скарги адвоката до регіональної ВЛК або ЦВЛК за Наказом МОУ №402 із вимогою контрольного стаціонарного обстеження та зупинення мобілізаційних дій на час перегляду.',
    tck: 'Статус «У розшуку» в Резерв+ та необґрунтовані штрафи ТЦК знімаються через офіційний адвокатський запит та адміністративний позов дистанційно — без ризикованого особистого візиту клієнта до ТЦК та СП.',
    zvilnennya: 'Адвокат фіксує подачу рапорту через офіційний адвокатський запит та контролює строки розгляду командуванням (або витребовує невиплачені бойові / ОГД), що унеможливлює «втрату» документів у стройовій частині.'
  };

  var STEPS = [
    {
      field: 'case_type',
      stepLabel: 'Крок 1 з 3 · Суть справи',
      progress: 33,
      title: '1. Яка у вас справа або ситуація?',
      sub: 'Оберіть напрямок, щоб система підключила вузькопрофільного військового адвоката:',
      options: [
        { code: 'szch', icon: '🪖', title: 'СЗЧ / Дезертирство / Кримінальне провадження', desc: 'Повернення на службу, переведення в іншу частину, захист у ДБР та суді' },
        { code: 'vlk', icon: '🏥', title: 'ВЛК / Оскарження рішення медкомісії', desc: 'Ігнорування діагнозів, перегляд через ЦВЛК, списання за станом здоров’я' },
        { code: 'tck', icon: '📋', title: 'ТЦК та мобілізація / Статус «У розшуку»', desc: 'Примусова доставка, Резерв+, оформлення відстрочки, зняття з розшуку' },
        { code: 'zvilnennya', icon: '📄', title: 'Звільнення зі служби / Рапорти / Виплати', desc: 'Сімейні обставини, 3 дітей, догляд за інвалідом, бойові виплати та ОГД' }
      ]
    },
    {
      field: 'urgency',
      stepLabel: 'Крок 2 з 3 · Терміновість',
      progress: 66,
      title: '2. Як терміново вам потрібна допомога адвоката?',
      sub: 'Від цього залежить пріоритет підключення чергового захисника:',
      options: [
        { code: 'critical', icon: '🔴', title: 'Критично терміново (вже сталася проблема)', desc: 'Вже є СЗЧ, затримання ТЦК, кримінальна справа або рішення ВЛК на руках' },
        { code: 'soon', icon: '🟡', title: 'Терміново — є кілька днів у запасі', desc: 'Готую документи, рапорт, скаргу до ЦВЛК або очікую виклик' },
        { code: 'plan', icon: '🔵', title: 'Планую наперед (превентивний захист)', desc: 'Хочу заздалегідь перевірити документи та мати адвоката на зв’язку' }
      ]
    },
    {
      field: 'ready_to_hire',
      stepLabel: 'Крок 3 з 3 · Формат роботи',
      progress: 92,
      title: '3. Чи готові ви найняти адвоката, який вирішить для вас цю справу?',
      sub: 'Офіційний договір про правничу допомогу через платформу КОНСУЛЬТАНТ («Безпечна угода»):',
      options: [
        { code: 'yes_ready', icon: '✅', title: 'Так, готовий(а) найняти профільного адвоката «під ключ»', desc: 'Головне — законно, безпечно та результативно вирішити проблему за договором' },
        { code: 'yes_price', icon: '🤝', title: 'Так, розглядаю платний супровід після оцінки вартості', desc: 'Хочу спочатку почути чіткий план дій адвоката та фіксовану ціну послуг' },
        { code: 'free_only', icon: 'ℹ️', title: 'Поки що вивчаю ситуацію самостійно', desc: 'Ознайомлююся із загальною інформацією без залучення адвоката' }
      ]
    }
  ];

  var iqStep = 0;
  var iqAnswers = {};
  var elStepTag = iqRoot.querySelector('.js-iq-step-tag');
  var elBar = iqRoot.querySelector('.js-iq-bar');
  var elQuestionsBox = iqRoot.querySelector('.js-iq-questions');
  var elTitle = iqRoot.querySelector('.js-iq-title');
  var elSub = iqRoot.querySelector('.js-iq-sub');
  var elOptions = iqRoot.querySelector('.js-iq-options');
  var elBack = iqRoot.querySelector('.js-iq-back');
  var elFinalBox = iqRoot.querySelector('.js-iq-final');
  var elSummaryTopic = iqRoot.querySelector('.js-iq-summary-topic');
  var elVerdictText = iqRoot.querySelector('.js-iq-verdict-text');
  var iqForm = iqRoot.querySelector('form.js-lead-form');

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function setField(name, value) {
    if (!iqForm) return;
    var input = iqForm.querySelector('[name="' + name + '"]');
    if (input) input.value = value || '';
  }

  function renderInlineStep() {
    if (iqStep < STEPS.length) {
      var s = STEPS[iqStep];
      elQuestionsBox.hidden = false;
      elFinalBox.hidden = true;
      elStepTag.textContent = s.stepLabel;
      elBar.style.width = s.progress + '%';
      elTitle.textContent = s.title;
      elSub.textContent = s.sub;
      elBack.hidden = iqStep === 0;

      elOptions.innerHTML = '';
      s.options.forEach(function (opt) {
        var btn = el('button', 'iq-opt' + (iqAnswers[s.field] && iqAnswers[s.field].code === opt.code ? ' is-selected' : ''));
        btn.type = 'button';
        var left = el('span', 'iq-opt__left');
        var icon = el('span', 'iq-opt__icon', opt.icon);
        icon.setAttribute('aria-hidden', 'true');
        var text = el('span', 'iq-opt__text');
        text.appendChild(el('b', null, opt.title));
        text.appendChild(el('small', null, opt.desc));
        left.appendChild(icon);
        left.appendChild(text);
        var radio = el('span', 'iq-opt__radio');
        radio.setAttribute('aria-hidden', 'true');
        btn.appendChild(left);
        btn.appendChild(radio);

        btn.addEventListener('click', function () {
          iqAnswers[s.field] = { code: opt.code, label: opt.title };
          btn.classList.add('is-selected');
          setTimeout(function () {
            iqStep++;
            renderInlineStep();
          }, 220);
        });
        elOptions.appendChild(btn);
      });
      return;
    }

    elQuestionsBox.hidden = true;
    elFinalBox.hidden = false;
    elStepTag.textContent = 'Готово · Профільного адвоката підібрано';
    elBar.style.width = '100%';

    var chosenCase = iqAnswers.case_type ? iqAnswers.case_type.label : 'Військове право';
    var chosenCode = iqAnswers.case_type ? iqAnswers.case_type.code : 'szch';
    if (elSummaryTopic) elSummaryTopic.textContent = chosenCase;
    if (elVerdictText && VERDICTS[chosenCode]) elVerdictText.textContent = VERDICTS[chosenCode];

    STEPS.forEach(function (s) {
      setField('q_' + s.field, iqAnswers[s.field] ? iqAnswers[s.field].label : '');
    });
    setDirection(iqForm, chosenCase);

    if (window.dataLayer) window.dataLayer.push({ event: 'inline_quiz_done' });
  }

  if (elBack) {
    elBack.addEventListener('click', function () {
      if (iqStep > 0) {
        iqStep--;
        renderInlineStep();
      }
    });
  }

  var elBackFromFinal = iqRoot.querySelector('.js-iq-back-final');
  if (elBackFromFinal) {
    elBackFromFinal.addEventListener('click', function () {
      iqStep = STEPS.length - 1;
      renderInlineStep();
    });
  }

  renderInlineStep();
})();
